import * as users from './user/actions';
import * as matches from './matches/actions';
import * as chats from './chats/actions';

const actionCreators = {
	users,
	matches,
	chats
};

export default actionCreators;
